module.exports = __webpack_public_path__ + "static/media/34-iveco-mercedes.0fc9f9cc.jpg";